import csstype.*
import csstype.LineStyle.Companion.solid
import emotion.react.css
import kotlinx.js.timers.clearTimeout
import kotlinx.js.timers.setTimeout
import react.*
import react.dom.html.InputType
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h1
import react.dom.html.ReactHTML.input
import kotlin.Float
import kotlinx.coroutines.*
import react.dom.html.ReactHTML.br
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.h3
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.wbr
import kotlin.random.Random

external interface WelcomeProps : Props {
    var name: String
    var time: Int
    var onGoing: Boolean

}

var rBaba = 0
var listCheck = ""
var textSep = 1f
var listSep = " "
val scope = CoroutineScope(Dispatchers.Default)



val Welcome = FC<WelcomeProps> { props ->
    var name by useState(props.name)
    var sec by useState(0)
    var ongo by useState(props.onGoing)
    val list by useState(arrayListOf<String>())
    val startOrEnd =
        when (ongo) {
            true -> FaStopCircle
            false -> FaPlayCircle
        }
    var guideBaba by useState(arrayListOf("to manage anxiety","1 breathe IN and OUT","2 remember Letters","3 press RELAX at BABA"))

    val scal : Float = when(sec%10)
    {
        0 -> 1.0f
        1,9 -> 0.8f
        2,8 -> 0.6f
        3,7 -> 0.4f
        4,6 -> 0.2f
        5 -> 0.0f
        else -> 1.0f
    }

    fun dorBaba(r: Int) {
        if(r==1) rBaba++
        else rBaba=0
    }

    fun doListcheck() {
        scope.launch {
            delay(3000)
            listCheck = ""
            cancel()
        }

    }

    val set = setTimeout(
        {
            if(ongo) {

                sec += 1

                if (sec % 10 == 4) {
                    listCheck = ""

                    if (list == mutableListOf("A", "B", "A", "B")) {
                        listCheck = "Lost: ${list.asReversed().joinToString(separator = "  ")}"
                        rBaba = 0
                        list.clear()
                        doListcheck()
                    }

                    scope.launch {
                        textSep = 1f
                        delay(500)
                        textSep = 0f
                        if (textSep == 0f) listSep = " "
                        delay(500)
                        cancel()
                    }


                    val rand = Random.nextInt(0, 2)
                    if (list.size >= 4) list.removeFirst()
                    if (rand == 0) list.add("A") else list.add("B")

                    listSep = "→"
                }
            }
        },1000)

    div {
        css {
            width = Auto.auto
        }

        div {
            css {
                height = 32.px
            }
        }
        div {
            css {
                width = 200.px
                display = Display.flex
                justifyContent = JustifyContent.spaceBetween
            }
            div {
                button {
                    css {
                        backgroundColor = NamedColor.mediumpurple
                        color = rgb(28, 27, 31)
                        border = 1.px
                        borderRadius = 8.px;
                        verticalAlign = VerticalAlign.bottom
                        fontSize = 16.px
                        hover { backgroundColor = NamedColor.rebeccapurple }
                        active {
                            backgroundColor = NamedColor.rebeccapurple
                            color = NamedColor.white
                        }
                    }
                    onClick = {
                        if (list == mutableListOf("A", "B", "A", "B")) {
                            listCheck = "Relaxed: ${list.asReversed().joinToString(separator = " ")}"
                            dorBaba(1)
                            list.clear()
                            doListcheck()
                        } else {
                            listCheck = "Failed: ${list.asReversed().joinToString(separator = " ")}"
                            dorBaba(0)
                            list.clear()
                            doListcheck()
                        }
                    }
                        +"RELAX"
                    }
                }
                div {
                    css {
                        color = NamedColor.lightgray
                        verticalAlign = VerticalAlign.middle
                    }
                    if (rBaba > 0) +"$rBaba" else +"0"
                }
            }
            div {
                h2 {
                    css {
                        color = NamedColor.white
                    }
                    if (listCheck == "") {
                        css {
                            color = NamedColor.white
                        }
                        list.asReversed().joinToString(separator = listSep).forEachIndexed() { index, it ->
                            if (it.toString() == "→" || it.toString() == " ") {
                                +"$it"
                            } else {
                                if (index != 0 && Random.nextInt(19) != 0) +"*" else +"$it"
                            }
                        }
                    } else {
                        css {
                            color = NamedColor.red
                        }
                        +"$listCheck"
                    }

                }
            }

            div {
                css {
                    height = 8.px
                }
            }
            div {
                css {
                    width = 200.px
                }
                p {
                    css {
                        color = NamedColor.lightgray
                        alignSelf = AlignSelf.flexEnd
                        verticalAlign = VerticalAlign.baseline
                    }
                    if (sec % 10 in 1..5) +"breathe OUT" else +"breathe IN"
                }
            }
            div {
                css {
                    width = 200.px
                    height = 200.px
                    backgroundColor = NamedColor.transparent
                    borderStyle = solid
                    borderWidth = 1.px
                    borderColor = NamedColor.blue
                }
                div {
                    css {
                        width = 200.px
                        height = 200.px
                        backgroundColor = NamedColor.blue
                        borderRadius = 100.px
                        if (ongo) transform = scale(scal) else scale(1)
                    }
                }
            }
            div {
                css {
                    width = 200.px
                    display = Display.flex
                    justifyContent = JustifyContent.spaceBetween
                }
                p {
                    css {
                        color = NamedColor.lightgray
                        verticalAlign = VerticalAlign.middle
                    }
                    if (ongo) +"$sec" else +"0"
                }
                button {
                    css {
                        backgroundColor = NamedColor.transparent
                        border = 0.px
                        boxShadow = BoxShadow(0.px, 0.px, NamedColor.transparent)
                        borderRadius = 0.px;
                        color = NamedColor.mediumpurple
                        verticalAlign = VerticalAlign.top
                        hover { color = NamedColor.rebeccapurple }
                        active {
                            color = NamedColor.rebeccapurple
                            color = NamedColor.white
                        }
                    }
                    onClick = {
                        name = "startOrEnd"
                        clearTimeout(set)
                        ongo = !ongo
                        sec = 0
                        listCheck = ""
                        list.clear()

                        if (ongo) {
                            guideBaba =
                                arrayListOf("result", "1 Relax: ${rBaba}", "2 Breath: ${sec / 10}", "3 Time: ${sec}")

                        } else if (!ongo) {
                            guideBaba = arrayListOf(
                                "to manage anxiety",
                                "1 breathe IN and OUT",
                                "2 remember Letters",
                                "3 press RELAX at BABA"
                            )
                        }
                    }
                    startOrEnd {
                        size = 32
                        round = true
                    }
                }
            }
        div {
            css {
                width = 200.px
                height = 16.px
            }
        }
        div {
            p {
                css {
                    width = 200.px
                    color = NamedColor.lightgray
                }
                guideBaba.forEach {
                    p {
                        +it
                    }
                }
            }
        }

        }
    }
